module.exports = __webpack_public_path__ + "images/sprites/ui/icon_ranking_normal_ef7e1785f9b7ea8c750329668c56f4d9.png";